__turbopack_context__.v({
  "animate": "gradientLines-module-scss-module__FkBfoq__animate",
  "gradientLine1": "gradientLines-module-scss-module__FkBfoq__gradientLine1",
  "gradientLine2": "gradientLines-module-scss-module__FkBfoq__gradientLine2",
  "gradientLine3": "gradientLines-module-scss-module__FkBfoq__gradientLine3",
  "gradientLine4": "gradientLines-module-scss-module__FkBfoq__gradientLine4",
  "gradientLines": "gradientLines-module-scss-module__FkBfoq__gradientLines",
});
